import * as Lambda from './LambdaApi';

const getFamilyList = async (residentId) => {
    const apiPath = `/residents/${residentId}/relatives`;
    const relativeData = await Lambda.Get(apiPath, {}, 'lambda');
    return relativeData;
};

const getA4hContacts = async (facilityId, residentId) => {
    const apiPath = `/s2l/${facilityId}/fetchA4hContacts`
    const body = {
       Filter:{
        _id: residentId,
       },
    }
    const a4hContactData = await Lambda.Post(apiPath, body, 'lambda')
    return a4hContactData
}

const getRelativeDetail = async (residentId, relativeId) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;
    const relativeData = await Lambda.Get(apiPath, {}, 'lambda');
    return relativeData;
};

const updateRelative = async (residentId, relativeId, payload) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;
    const relativeData = await Lambda.Put(apiPath, { ...payload }, 'lambda');
    return relativeData;
};

const updateRelativeImage = async (residentId, relativeId, imageURL) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;
    const relativeData = await Lambda.Put(apiPath, { Image: imageURL }, 'lambda');
    return relativeData;
};

const updateCanListenToStories = async (residentId, relativeId, value) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;

    const relativeData = await Lambda.Put(
        apiPath,
        {
            canListenToStories: value,
        },
        'lambda',
    );

    return relativeData;
};

const updateAnnouncementAlerts = async (residentId, relativeId, value, FirstName, LastName) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;

    const relativeData = await Lambda.Put(
        apiPath,
        {
            FirstName: FirstName,
            LastName: LastName,
            announcementAlerts: Boolean(value),
        },
        'lambda',
    );

    return relativeData;
};

const updateCanRecieveRequests = async (residentId, relativeId, value) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;

    const relativeData = await Lambda.Put(
        apiPath,
        {
            canRecieveRequests: value,
        },
        'lambda',
    );

    return relativeData;
};
const updateCanSeeFeed = async (residentId, relativeId, value) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;

    const relativeData = await Lambda.Put(
        apiPath,
        {
            canSeeFeed: value,
        },
        'lambda',
    );

    return relativeData;
};
const updateManager = async (residentId, relativeId, value) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}`;

    const relativeData = await Lambda.Put(
        apiPath,
        {
            Manager: value, 
        },
        'lambda',
    );
    
    return relativeData;
};
const deleteRelative = async (relativeId) => {
    //used by logged in user to delete their own account
    const apiPath = `/relatives/${relativeId}`;
    const deleteResponse = await Lambda.Delete(apiPath, {}, 'lambda');
    console.log({deleteResponse});
    return deleteResponse;
}
export {
    getFamilyList,
    getA4hContacts,
    getRelativeDetail,
    updateRelative,
    updateRelativeImage,
    updateCanListenToStories,
    updateAnnouncementAlerts,
    updateCanRecieveRequests,
    updateCanSeeFeed,
    updateManager,
    deleteRelative
};
